import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormsCircleSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormsCircleSquare"><Path d="M21 21H8V17.4395C8.32808 17.4779 8.66159 17.5 9 17.5C13.6944 17.5 17.5 13.6944 17.5 9C17.5 8.66159 17.4779 8.32808 17.4395 8H21V21Z" fill="currentColor"/><Path d="M9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormsCircleSquare;
